import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from 'components/RMSDialog';
import TextField2 from 'components/RMSTextField';
import { ColCard, gridStyle, Row, RowInner, useError, formatSaveData } from 'utils/formStyles';
import Dictionary from 'components/RMSAutoComplete/RMSDictonary';
import { showSpinner, hideSpinner } from 'reducers/UiReducer';
import { handleError } from 'reducers/ErrorReducer';
import { notifyDataUpdate } from 'reducers/DataUpdateReducer';
import { notify } from 'reducers/NotifierReducer';
import { closePeopleEmployment } from 'reducers/PersonDialogsReducer';
import PlaceLookup from 'components/RMSPlaceLookup';
import PersonLookup2 from 'components/RMSPersonLookup/PersonLookup2';
import BackDatedRecordHistory from 'components/BackDatedRecordHistory';

import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { addPersonEmployment, editPersonEmployment } from 'reducers/SearchReducer';
import { addUpdatedBy } from 'utils/functions';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  fileInfo: {
    minHeight: 35,
    marginBottom: 16,
    '& img': {
      maxHeight: 24,
      borderRadius: 3,
      marginRight: 8,
    },
  },
  item: gridStyle(300, '100%'),
  txtField: {
    minWidth: 350,
  },
  closeButton: { color: theme.button.color },
}));

function PeopleEmploymentDialog(props) {
  const classes = useStyles();
  const { data } = props;
  const { ptsPersonID } = data;
  const [Place, setPlace] = useState(null);
  const [DepartmentName, setDepartmentName] = useState('');
  const [Position, setPosition] = useState(null);
  const [Occupation, setOccupation] = useState(null);
  const [Rank, setRank] = useState(null);
  const [Status, setStatus] = useState(null);
  const [Pay, setPay] = useState('');
  const [Rate, setRate] = useState(null);
  const [supervisor, setSupervisor] = useState(null);
  const [Shift, setShift] = useState('');
  const [Hired, setHired] = useState(null);
  const [Terminated, setTerminated] = useState(null);
  const [TerminationReason, setTerminationReason] = useState(null);
  const [Notes, setNotes] = useState('');

  const [recordHistoryData, setRecordHistoryData] = useState({
    shouldVisible: true,
    isDisabled: true,
    createUpdateInfo: {},
  });
  const [showRecordHistory, setShowRecordHistory] = useState(false);

  const [errors, setErrors] = useState();
  const { err, isValidAndChanged, formChanged } = useError(errors, setErrors);
  const isEdit = typeof data === 'object';

  // useEffect(() => {
  //   if (pts) {
  //     const { ptsCredentialID, Type, ptsPersonID, Number } = data;
  //     setType(Type);
  //     setNumber(Number);
  //   }

  //   // eslint-disable-next-line
  // }, []);
  useEffect(() => {
    if (data.ptsPersonID && data.ptsPlaceID) {
      setRecordHistoryData({
        shouldVisible: true,
        isDisabled: !data.Created,
        createUpdateInfo: {
          created: data.Created,
          createdBy: data.CreatedBy,
          updated: data.Updated,
          updatedBy: data.UpdatedBy,
        },
      });

      setPlace({ ptsPlaceID: data.ptsPlaceID });
      setDepartmentName(data.DepartmentName);
      setPosition(data.Position);
      setOccupation(data.Occupation);
      setRank(data.Rank);
      setStatus(data.Status);
      setPay(data.Pay);
      setRate(data.Rate);
      setSupervisor({ ptsPersonID: data.ptsSupervisorID });
      setShift(data.Shift);
      setHired(data.Hired);
      setTerminated(data.Terminated);
      setTerminationReason(data.TerminationReason);
      setNotes(data.Notes);
    }
  }, [data]);

  const handleCloseRecordHistoryDialog = () => setShowRecordHistory(false);

  const close = () => {
    props.closePeopleEmployment();
  };

  const save = async () => {
    const employmentData = formatOutData();
    props.showSpinner();
    try {
      if (data.ptsPersonID && data.ptsPlaceID) {
        const updatedData = addUpdatedBy(employmentData);
        await editPersonEmployment(
          { ptsPersonID: data.ptsPersonID, ptsPlaceID: data.ptsPlaceID },
          updatedData
        );
      } else {
        await addPersonEmployment(employmentData);
      }
      props.notifyDataUpdate({ type: 'employment' });
      close();
    } catch (err) {
      props.handleError(err);
    }
    props.hideSpinner();
  };

  const formatOutData = () => {
    const formatData = formatSaveData({
      DepartmentName,
      Position,
      Occupation,
      Rank,
      Status,
      Pay,
      Rate,
      Shift,
      Hired,
      Terminated,
      TerminationReason,
      Notes,
    });
    formatData.Hired = Hired ? moment(Hired).format('YYYY-MM-DD') : null;
    formatData.Terminated = Terminated ? moment(Terminated).format('YYYY-MM-DD') : null;
    formatData.ptsPlaceID = Place?.ptsPlaceID;
    formatData.ptsSupervisorID = supervisor ? supervisor.ptsPersonID : null;
    formatData.ptsPersonID = ptsPersonID;
    return formatData;
  };

  const renderEmployer = () => {
    const onChange = (val) => {
      setPlace(val);
      formChanged();
    };
    const error = err(Place, 'Place');
    return (
      <PlaceLookup
        disabled={!!data.ptsPlaceID}
        onChange={onChange}
        className={classes.item}
        label="Employer"
        error={error}
        ptsPlaceID={Place?.ptsPlaceID}
      />
    );
  };

  const renderDepartmentName = () => {
    const onChange = (ev, val) => {
      setDepartmentName(val);
      formChanged();
    };
    return (
      <TextField2
        className={classes.item}
        label="Department Name"
        value={DepartmentName}
        onChange={onChange}
        max={40}
      />
    );
  };

  const renderPosition = () => {
    const onChange = (ev, val) => {
      setPosition(val);
      formChanged();
    };
    return (
      <Dictionary
        className={classes.item}
        options="codePositions"
        onChange={onChange}
        formType={isEdit}
        value={Position}
        label="Position"
      />
    );
  };

  const renderOccupation = () => {
    const onChange = (ev, val) => {
      setOccupation(val);
      formChanged();
    };
    return (
      <Dictionary
        className={classes.item}
        options="codeOccupations"
        formType={isEdit}
        onChange={onChange}
        value={Occupation}
        label="Occupation"
      />
    );
  };

  const renderRank = () => {
    const onChange = (ev, val) => {
      setRank(val);
      formChanged();
    };
    return (
      <Dictionary
        className={classes.item}
        options="codeRanks"
        formType={isEdit}
        onChange={onChange}
        value={Rank}
        label="Rank"
      />
    );
  };

  const renderStatus = () => {
    const onChange = (ev, val) => {
      setStatus(val);
      formChanged();
    };
    return (
      <Dictionary
        className={classes.item}
        options="codeEmploymentStatuses"
        formType={isEdit}
        onChange={onChange}
        value={Status}
        label="Status"
      />
    );
  };

  const renderPay = () => {
    const onChange = (ev, val) => {
      setPay(val);
      formChanged();
    };
    return (
      <TextField2
        className={classes.item}
        label="Pay"
        value={Pay}
        onChange={onChange}
        type="number"
      />
    );
  };

  const renderRate = () => {
    const onChange = (ev, val) => {
      setRate(val);
      formChanged();
    };
    return (
      <Dictionary
        className={classes.item}
        options="PayRates"
        formType={isEdit}
        onChange={onChange}
        value={Rate}
        label="Rate"
      />
    );
  };

  const renderSupervisor = () => {
    const onChange = (val) => {
      setSupervisor(val);
      formChanged();
    };
    return (
      <PersonLookup2
        className={classes.item}
        onPersonChange={onChange}
        label="Supervisor"
        ptsPersonID={supervisor?.ptsPersonID}
      />
    );
  };

  const renderShift = () => {
    const onChange = (ev, val) => {
      setShift(val);
      formChanged();
    };
    return (
      <TextField2
        className={classes.item}
        label="Shift"
        value={Shift}
        onChange={onChange}
        max={50}
      />
    );
  };

  const renderHired = () => {
    const onChange = (val) => {
      setHired(val);
      formChanged();
    };
    return (
      <KeyboardDatePicker
        disableOpenOnEnter
        autoComplete="off"
        disableToolbar
        variant="inline"
        inputVariant="outlined"
        format="MM/dd/yyyy"
        margin="normal"
        label="Hired"
        value={Hired}
        onChange={onChange}
        maxDate={Terminated}
        autoOk
        size="small"
        className={classes.item}
        style={{ marginBottom: 16 }}
      />
    );
  };

  const renderTerminated = () => {
    const onChange = (val) => {
      setTerminated(val);
      formChanged();
    };
    return (
      <KeyboardDatePicker
        disableOpenOnEnter
        autoComplete="off"
        disableToolbar
        variant="inline"
        inputVariant="outlined"
        format="MM/dd/yyyy"
        margin="normal"
        label="Terminated"
        value={Terminated}
        onChange={onChange}
        minDate={Hired}
        autoOk
        size="small"
        className={classes.item}
        style={{ marginBottom: 16 }}
      />
    );
  };

  const renderTerminationReason = () => {
    const onChange = (ev, val) => {
      setTerminationReason(val);
      formChanged();
    };
    return (
      <Dictionary
        className={classes.item}
        options="codeTerminationReasons"
        formType={isEdit}
        onChange={onChange}
        value={TerminationReason}
        label="Termination Reason"
      />
    );
  };

  const renderNotes = () => {
    const onChange = (ev, val) => {
      setNotes(val);
      formChanged();
    };
    return (
      <TextField2
        className={classes.item}
        label="Notes"
        value={Notes}
        onChange={onChange}
        max={2000}
        multiline
        rows={3}
      />
    );
  };

  const renderActions = () => {
    return (
      <>
        {recordHistoryData?.shouldVisible && (
          <Box className="">
            <BackDatedRecordHistory
              showRecordHistory={showRecordHistory}
              setShowRecordHistory={setShowRecordHistory}
              disabled={recordHistoryData?.isDisabled}
              handleCloseRecordHistoryDialog={handleCloseRecordHistoryDialog}
              createUpdateInfo={recordHistoryData?.createUpdateInfo}></BackDatedRecordHistory>
          </Box>
        )}
        <Button
          color="primary"
          variant="contained"
          autoFocus
          onClick={save}
          disabled={!isValidAndChanged()}>
          <SaveIcon /> Save
        </Button>
        <Button color="primary" onClick={close} className={classes.closeButton}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  return (
    <Dialog
      toolbar
      onClose={close}
      title={isEdit ? 'Edit Employment' : 'Add Employment'}
      actions={renderActions()}>
      <Row>
        <ColCard minWidth={500}>
          <RowInner>
            {renderEmployer()}
            {renderDepartmentName()}
            {renderPosition()}
            {renderOccupation()}
            {renderRank()}
            {renderStatus()}
            {renderPay()}
            {renderRate()}
            {renderSupervisor()}
            {renderShift()}
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              {renderHired()}
              {renderTerminated()}
            </MuiPickersUtilsProvider>
          </RowInner>
          <RowInner>{renderTerminationReason()}</RowInner>
          <RowInner>{renderNotes()}</RowInner>
        </ColCard>
      </Row>
    </Dialog>
  );
}

export default connect(null, {
  showSpinner,
  hideSpinner,
  handleError,
  notify,
  notifyDataUpdate,
  closePeopleEmployment,
})(PeopleEmploymentDialog);
